<template>
    <div >
        <v-select
            v-model="$i18n.locale"
            :items="this.langs"
            label="Language"
            outlined
            dense
        >
        </v-select>
    </div>
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return {
        langs: ['de-DE', 'en-US']
    }
  }
}
</script>